import { GeneratorControlButton } from './common'
import SVG from 'react-inlinesvg'
import { MotifGeneratorType } from '../MotifPatternGenerator/types'
import { useContextMotifGenerator } from '../../contexts/motifGeneratorContext'
import { useContextScreensaver } from '../../contexts/screensaverContext'
import { useContextOnboarding } from '../../contexts/onboardingContext'
import { FeatureDiscoveryElement } from '../../types/FeatureDiscoveryElement'

const PatternButtons = () => {
  const { exportModal, setExportModal } = useContextMotifGenerator()
  const { setIsScreensaverOn } = useContextScreensaver()
  const {
    setFeatureDiscoveryElementsOpen,
    featureDiscoveryElementsAlreadyShown,
    setFeatureDiscoveryElementsAlreadyShown,
  } = useContextOnboarding()
  const { selectedGeneratorType, selectGeneratorType, isRegenerated, setIsRegenerated } =
    useContextMotifGenerator()

  // Replace these with the commented out lines below if you
  // want to have freehand generator in place
  const firstRow = [
    { src: 'round_pattern.svg', type: MotifGeneratorType.CIRCLE },
    { src: 'square_pattern.svg', type: MotifGeneratorType.SQUARE },
    { src: 'penrose.svg', type: MotifGeneratorType.PENROSE },
    { src: 'random_pattern.svg', type: MotifGeneratorType.MAP },
  ]

  const secondRow = [
    { src: 'square.svg', type: MotifGeneratorType.KALEIDO_SQUARE },
    { src: 'pentagon.svg', type: MotifGeneratorType.KALEIDO_PENTA },
    { src: 'hexagon.svg', type: MotifGeneratorType.KALEIDO_HEXA },
    { src: 'free.svg', type: MotifGeneratorType.FREE },
  ]

  const handleClick = (type: MotifGeneratorType) => {
    setIsScreensaverOn(false)
    if (exportModal) setExportModal(false) // Close the modal when switching generators
    if (
      featureDiscoveryElementsAlreadyShown.includes(FeatureDiscoveryElement.HOME) ||
      featureDiscoveryElementsAlreadyShown.includes(FeatureDiscoveryElement.PATTERNLIST) ||
      featureDiscoveryElementsAlreadyShown.includes(FeatureDiscoveryElement.ACTIONS)
    ) {
      setFeatureDiscoveryElementsOpen([])
    } else if (selectedGeneratorType === MotifGeneratorType.FREE) {
      setFeatureDiscoveryElementsOpen([
        FeatureDiscoveryElement.HOME,
        FeatureDiscoveryElement.PATTERNLIST,
        FeatureDiscoveryElement.ACTIONS,
      ])
      setFeatureDiscoveryElementsAlreadyShown([
        FeatureDiscoveryElement.HOME,
        FeatureDiscoveryElement.PATTERNLIST,
        FeatureDiscoveryElement.ACTIONS,
      ])
    } else {
      setFeatureDiscoveryElementsOpen([])
    }

    selectGeneratorType(type)
    if (selectedGeneratorType === MotifGeneratorType.MAP) {
      setIsRegenerated(!isRegenerated)
    }
  }

  return (
    <>
      <div className="flex flex-col justify-between gap-[10px] md:gap-[18px]">
        {firstRow.map((item, index) => (
          <GeneratorControlButton
            key={index}
            onClick={() => handleClick(item.type)}
            active={selectedGeneratorType === item.type}
          >
            <SVG
              className="absolute left-1/2 top-1/2 size-[72%] max-h-[40px] max-w-[40px] [transform:translate(-50%,-50%)]"
              src={`/icons/patterns/${item.src}`}
            />
          </GeneratorControlButton>
        ))}
      </div>
      <div className="flex flex-col justify-between gap-[10px] md:gap-[18px]">
        {secondRow.map((item, index) => (
          <GeneratorControlButton
            key={index}
            onClick={() => handleClick(item.type)}
            active={selectedGeneratorType === item.type}
          >
            <SVG
              className="absolute left-1/2 top-1/2 size-[72%] max-h-[40px] max-w-[40px] [transform:translate(-50%,-50%)]"
              src={`/icons/patterns/${item.src}`}
            />
          </GeneratorControlButton>
        ))}
      </div>
      {
        // TODO: Use the third row here when the freehand generator is done
        // <div className="flex flex-col justify-between gap-[10px] md:gap-[18px]">
        //   {thirdRow.map((item, index) => (
        //     <GeneratorControlButton
        //       key={index}
        //       onClick={() => handleClick(item.type)}
        //       active={selectedGeneratorType === item.type}
        //     >
        //       <SVG src={`/icons/patterns/${item.src}`} />
        //     </GeneratorControlButton>
        //   ))}
        // </div>
      }
    </>
  )
}

export default PatternButtons
